/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricsAggregateTrendRequest {
    getFixupPrototypeFunction() { return UtilizationMetricsAggregateTrendRequest.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricsAggregateTrendRequest>): UtilizationMetricsAggregateTrendRequest {
        let obj = Object.assign(new UtilizationMetricsAggregateTrendRequest(), model);
        UtilizationMetricsAggregateTrendRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricsAggregateTrendRequest>): UtilizationMetricsAggregateTrendRequest {
        if (!model) return null;
        return UtilizationMetricsAggregateTrendRequest.newInstance(<UtilizationMetricsAggregateTrendRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricsAggregateTrendRequest) {
        if (!obj) return;

        models.UtilizationMetricsAggregateTrendRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricsAggregateTrendRequest): boolean {
        Object.setPrototypeOf(obj, UtilizationMetricsAggregateTrendRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.granularity === undefined) {
            this.granularity = 0;
        }
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * specify the start date.
     */
    start_date: Date;

    /**
     * specify the end date.
     */
    end_date: Date;

    /**
     * specify the granularity in seconds. Allowed values are 60, 300, 3600.
     */
    granularity: number;

    /**
     * Query expression to filter.
     */
    filters: models.QueryOperator;

}
